import styled from "styled-components";
import { Link } from "react-router-dom";
import {Link as LinkScroll} from 'react-scroll'
import * as palette from "../../SCVariables";

export const FooterContainer = styled.footer`
  background: ${palette.mainBlack};
  color:${palette.mainWhite};
`;
export const FooterWrap = styled.div`
  padding: 48px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 1100px;
  margin: 0 auto;
`;

export const HR = styled.hr`
  border: 1px solid ${palette.mainWhite};

  @media screen and (max-width: 768px) {
    margin-bottom: 50px;
  }
`;

export const FooterLinksContainer = styled.div`
  display: flex;
  justify-content: flex-start;

  @media screen and (max-width: 820px) {
    padding-top: 32px;
  }
`;

export const FooterLinksWrapper = styled.div`
  display: flex;

  @media screen and (max-width: 820px) {
    flex-direction: column;
  }
`;

export const FooterLinkItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 16px;
  text-align: left;
  width: 160px;
  box-sizing: border-box;

  @media screen and (max-width: 420px) {
    margin: 0;
    padding: 10px;
    width: 100%;
  }
`;
export const FooterLinkTitle = styled.h1`
  font-size: 14px;
  margin-bottom: 16px;
`;

export const FooterLinkScroll = styled(LinkScroll)`
  color: ${palette.mainWhite};
  text-decoration: none;
  margin-bottom: 0.5rem;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    color: ${palette.mainOrange};
    transition: 0.3s ease-out;
  }
`;
export const FooterLinkAnchor = styled.a`
  color: ${palette.mainWhite};
  text-decoration: none;
  margin-bottom: 0.5rem;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    color: ${palette.mainOrange};
    transition: 0.3s ease-out;
  }
`;

export const SocialMedia = styled.div`
  max-width: 1000px;
  width: 100%;
`;

export const SocialMediaWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1100px;
  margin: 40px auto 0 auto;

  @media screen and (max-width: 820px) {
    flex-direction: column;
  }
`;

export const SocialLogo = styled(Link)`
  color: ${palette.mainWhite};
  justify-self: start;
  cursor: pointer;
  text-decoration: none;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-weight: bold;
`;

export const WebsiteRights = styled.small`
  color: ${palette.mainWhite};
  margin-bottom: 16px;
`;

export const SocialIcons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 240px;
`;

export const SocialIconLink = styled.a`
  color: ${palette.mainWhite};
  font-size: 24px;
`;
